module.exports = __webpack_public_path__ + "static/media/tm6_6.9e2e109d.svg";